<template>
  <div class="lamp-content">
    <el-form
      :model="editOne"
      label-position="left"
      label-width="140px"
    >
      <div class="user-info">
        <el-form-item label="是否提前" prop="is_advance">
          <el-radio-group v-model="editOne.is_advance">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="操作类型" prop="is_advance_type" v-if="editOne.is_advance">
          <el-radio-group v-model="editOne.is_advance_type">
            <el-radio :label="1">开灯</el-radio>
            <el-radio :label="0">关灯</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="提前时间（分钟）" prop="advance_minute" v-if="editOne.is_advance">
          <el-input-number v-model="editOne.advance_minute" :min="1" :max="30" class="my_number"></el-input-number>
        </el-form-item>
        <div style="border-bottom:1px solid #dfdfdf;margin-bottom:10px;"></div>
        <el-form-item label="是否延迟" prop="is_delay">
          <el-radio-group v-model="editOne.is_delay">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="操作类型" prop="is_delay_type" v-if="editOne.is_delay">
          <el-radio-group v-model="editOne.is_delay_type">
            <el-radio :label="1">开灯</el-radio>
            <el-radio :label="0">关灯</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="延迟时间（分钟）" prop="delay_minute" v-if="editOne.is_delay">
          <el-input-number v-model="editOne.delay_minute" :min="1" :max="30" class="my_number"></el-input-number>
        </el-form-item>

      </div>
    </el-form>
    <br />
    <div slot="footer" class="dialog-footer lnglat-strategy">
      <el-button
        type="primary"
        @click="saveLnglatStg"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
import strategyApi from "@/api/light/strategy"
export default {
  name: "lnglatStrategy",
  props: {
    lnglatData: {
      type: Object
    },
  },
  data() {
    return {
      editOne: {
        is_advance: 0,
        is_advance_type: 0,
        advance_minute: 0,
        is_delay: 0,
        delay_minute: 0,
        is_delay_type: 0
      }
    }
  },
  mounted(){
    this.getInfo()
  },
  methods: {
    getInfo(){
      strategyApi.getStrategyInfo(this.lnglatData.stg_id).then((res) => {
        if (res.data.code === 1000) {
          this.editOne = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    saveLnglatStg(){
      strategyApi.strategyEdit(this.lnglatData.stg_id,this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功")
          this.$emit('closeMethod')
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>
<style lang='less'>
.my_number {
  width: 120px;
  .el-input__inner{
    height:28px !important;
    line-height:28px !important;
  }
}
.lnglat-strategy{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>